import { FlowStepEditor } from "../FlowStepEditor";
import { FlowExecutionData } from "../../../rule-engine-core/Flow/Engine/FlowExecutionData";
import React from "react";
import { LogStep } from "../../../rule-engine-core/Flow/Steps/General/LogStep";

export class LogStepEditor extends FlowStepEditor<LogStep> {
    renderEditUI(): JSX.Element | null {
        return <div>edit log step</div>;
    }

    // eslint-disable-next-line
    start(thread: string, data: FlowExecutionData): void {}
}
